var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EditorState } from 'prosemirror-state';
import { EditorView } from 'prosemirror-view';
import React, { createContext, useContext, useState } from 'react';
var EditorStateContext = createContext(null);
var EditorViewContext = createContext(null);
export var useEditorState = function () {
    var context = useContext(EditorStateContext);
    if (!context) {
        throw new Error("useEditorState is only available inside EditorProvider");
    }
    return context;
};
export var useEditorView = function () {
    var context = useContext(EditorViewContext);
    if (!context) {
        throw new Error("useEditorView is only available inside EditorProvider");
    }
    return context;
};
export var EditorProvider = function (_a) {
    var doc = _a.doc, schema = _a.schema, _b = _a.plugins, plugins = _b === void 0 ? [] : _b, editorProps = _a.editorProps, 
    // handleDocChange,
    children = _a.children;
    var _c = useState(function () {
        return EditorState.create({ doc: doc, schema: schema, plugins: plugins });
    }), state = _c[0], setState = _c[1];
    var view = useState(function () {
        return new EditorView(undefined, __assign(__assign({}, editorProps), { state: state, dispatchTransaction: function (tr) {
                // const doc = this.state.doc
                var state = this.state.apply(tr);
                view.updateState(state);
                setState(state);
                // if (handleDocChange && state.doc !== doc) {
                //   handleDocChange(state.doc)
                // }
            } }));
    })[0];
    // useEffect(() => {
    //   return () => view.destroy()
    // })
    return (React.createElement(EditorStateContext.Provider, { value: state },
        React.createElement(EditorViewContext.Provider, { value: view }, children)));
};
